<template>
  <div class="case-creation__step case-creation__test">
    <el-form ref="form" :model="form">
      <div class="test-reports-input-container">
        <div class="test-tabs">
          <div class="test-reports">
            <div
              v-if="
                this.getAuthenticatedUser &&
                this.getAuthenticatedUser.user_type == 'LAB_TECHNOLOGIST'
              "
            >
              <el-form-item
                label="Case Type"
                class="case-type-left mandatory-field"
                v-if="
                  getCaseInformation &&
                  getCaseInformation.case_types &&
                  getCaseInformation.case_types.length
                "
              >
                <el-select
                  v-model="form.case_type"
                  placeholder="Select Case Type"
                >
                  <el-option
                    v-for="(caseType, index) of caseTypes"
                    :label="caseTypeMap[caseType]"
                    :value="caseType"
                    :key="index"
                  >
                    <span>{{ caseTypeMap[caseType] }}</span>
                  </el-option>
                </el-select>
                <p
                  class="err"
                  v-if="
                    getUploadTestReportValidationErrors &&
                    getUploadTestReportValidationErrors.case_type
                  "
                >
                  {{ getUploadTestReportValidationErrors.case_type }}
                </p>
              </el-form-item>
            </div>
            <div v-else>
              <el-form-item
                label="Case Type"
                class="case-type-left mandatory-field"
                v-if="
                  getCaseInformation &&
                  getCaseInformation.case_types &&
                  getCaseInformation.case_types.length
                "
              >
                <el-select
                  v-model="form.case_type"
                  placeholder="Select Case Type"
                >
                  <el-option
                    v-for="(caseType, index) of getCaseInformation.case_types"
                    :label="caseTypeMap[caseType]"
                    :value="caseType"
                    :key="index"
                  >
                    <span>{{ caseTypeMap[caseType] }}</span>
                  </el-option>
                </el-select>
                <p
                  class="err"
                  v-if="
                    getUploadTestReportValidationErrors &&
                    getUploadTestReportValidationErrors.case_type
                  "
                >
                  {{ getUploadTestReportValidationErrors.case_type }}
                </p>
              </el-form-item>
            </div>

            <div class="document-reports">
              <div class="regular-reports">
                <p style="opacity: 0">Dummy File</p>
                <el-switch
                  v-model="form.is_supplemental_report"
                  @change="handleTypeChange"
                  active-text="Supplemental Report"
                  inactive-text="Regular Report  "
                  :disabled="checkSendout"
                ></el-switch>
              </div>
              <div class="single-reports" v-if="form.is_supplemental_report">
                <p style="opacity: 0">Dummy File</p>
                <div class="regular-reports single-report">
                  <el-switch
                    class="text-right"
                    v-model="multiple_supplemental_report"
                    @change="handleReportChange"
                    active-text="Multiple Reports"
                    inactive-text="Single Report"
                  ></el-switch>
                </div>
              </div>
              <div
                class="mark"
                v-if="!form.is_supplemental_report && !isPhysicianLogin"
              >
                <p style="opacity: 0">Dummy File</p>
                <div class="search-checkbox">
                  <div class="physican">
                    <el-checkbox
                      v-model="form.mark_for_physician"
                      label="Mark for Physician"
                      size="large"
                      :disabled="isLabAssistant"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="types">
            <el-row :gutter="20">
              <el-col :xl="4" :lg="5">
                <div class="case-type input-value">
                  <el-form-item label="Report Title" class="mandatory-field">
                    <el-input
                      v-model="form.title"
                      :disabled="checkReportTitle"
                      placeholder="Enter Report Title"
                    ></el-input>
                    <p
                      class="err"
                      v-if="
                        getUploadTestReportValidationErrors &&
                        getUploadTestReportValidationErrors.title
                      "
                    >
                      {{ getUploadTestReportValidationErrors.title }}
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="5" :lg="5">
                <div class="case-type input-value">
                  <el-form-item label="Reason" class="mandatory-field">
                    <el-input
                      v-model="form.reason"
                      placeholder="Enter Reason"
                    />
                    <p
                      class="err"
                      v-if="
                        getUploadTestReportValidationErrors &&
                        getUploadTestReportValidationErrors.reason
                      "
                    >
                      {{ getUploadTestReportValidationErrors.reason }}
                    </p>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :xl="5" :lg="4" v-if="form.case_type == 'COVID'">
                <div class="case-type input-value">
                  <el-form-item label="Covid Status" class="mandatory-field">
                    <el-select
                      v-model="form.covid_status"
                      placeholder="Select Covid Status"
                    >
                      <el-option
                        v-for="(item, index) in covidStatuses"
                        :key="index"
                        :value="item.value"
                        :label="item.label"
                      ></el-option>
                    </el-select>
                    <p
                      class="err"
                      v-if="
                        getUploadTestReportValidationErrors &&
                        getUploadTestReportValidationErrors.covid_status
                      "
                    >
                      {{ getUploadTestReportValidationErrors.covid_status }}
                    </p>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :xl="5" :lg="5" v-if="resultTypeField">
                <div class="case-type input-value">
                  <el-form-item label="Result" 
                    class="case-type-left mandatory-field" 
                  >
                  <el-select v-model="form.result_status"
                    placeholder="Select Result" 
                  >
                      <el-option label="POSITIVE" 
                        value="POSITIVE" 
                      />
                      <el-option label="NEGATIVE" 
                        value="NEGATIVE" 
                      />
                  </el-select> 
                  <p
                      class="err"
                      v-if="
                        getUploadTestReportValidationErrors &&
                        getUploadTestReportValidationErrors.result_status
                      "
                    >
                      
                      {{ getUploadTestReportValidationErrors.result_status }}
    
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="5" :lg="5" v-if="form.is_supplemental_report">
                <div class="case-type input-value">
                  <el-form-item
                    label="Reference Lab Name"
                    class="mandatory-field"
                  >
                    <el-input
                      v-model="form.reference_by"
                      placeholder="Reference lab name"
                    ></el-input>
                    <p
                      class="err"
                      v-if="
                        getUploadTestReportValidationErrors &&
                        getUploadTestReportValidationErrors.reference_by
                      "
                    >
                      {{ getUploadTestReportValidationErrors.reference_by }}
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="6" :lg="6">
                <div class="case-type input-value view-reports-dialog">
                  <label for="text" class="name-report"> Report File </label>
                  <el-upload
                    v-if="
                      form.is_supplemental_report &&
                      multiple_supplemental_report
                    "
                    class="upload-demo"
                    action=""
                    :before-remove="beforeReportRemove"
                    :on-remove="handleReportRemove"
                    :file-list="files"
                    :auto-upload="false"
                    accept=".pdf"
                    :multiple="true"
                    :on-change="handleMultipleFileUpload"
                    :show-file-list="false"
                  >
                    <el-button type="primary">
                      <img
                        src="@/assets/images/icons/attachments-icon.svg"
                        alt=""
                      />
                      Add file or Drag & drop file here</el-button
                    >
                  </el-upload>
                  <el-upload
                    v-else
                    class="upload-demo"
                    action=""
                    :before-remove="beforeRemove"
                    :on-change="handleUpload"
                    :on-remove="handleRemove"
                    :file-list="files"
                    :auto-upload="false"
                    accept=".pdf"
                    :show-file-list="false"
                  >
                    <el-button type="primary">
                      <img
                        src="@/assets/images/icons/attachments-icon.svg"
                        alt=""
                      />
                      Add file or Drag & drop file here</el-button
                    >
                    <template #tip> </template>
                  </el-upload>
                </div>
              </el-col>
              <el-col
                :xl="6"
                :lg="6"
                v-if="
                  this.getCaseInformation &&
                  this.getCaseInformation.case_types &&
                  this.getCaseInformation.case_types.includes('UTI')
                "
              >
                <div
                  class="case-type input-value view-reports-dialog auto-upload"
                >
                  <label for="text" class="name-report">
                    Discrete Results
                  </label>
                  <el-upload
                    ref="discreteUpload"
                    class="upload-demo"
                    action=""
                    :auto-upload="false"
                    accept=".csv"
                    :on-change="uploadDiscreteResults"
                    :file-list="discreteFileList"
                    :show-file-list="true"
                  >
                    <el-button type="primary">
                      <img
                        src="@/assets/images/icons/attachments-icon.svg"
                        alt=""
                      />
                      Upload discrete results file</el-button
                    >
                    <template #tip> </template>
                  </el-upload>
                </div>
              </el-col>
              <el-col
                :xl="4"
                :lg="3"
                v-if="
                  form.is_supplemental_report && multiple_supplemental_report
                "
              >
                <div class="input-value btn view-report">
                  <el-button
                    @click="onSubmitMultipleTestReports()"
                    :loading="loading"
                    :disabled="checkButtonDisabled || progressBar"
                    class="submit-report"
                  >
                    SUBMIT
                  </el-button>
                </div>
              </el-col>
              <el-col :xl="3" :lg="3" v-else>
                <div class="input-value btn view-report">
                  <el-button
                    @click="onSubmitTestReports()"
                    :loading="documentLoading"
                    :disabled="checkButtonDisabled"
                    class="submit-report"
                  >
                    SUBMIT
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div
          class="attached-files"
          v-if="!multiple_supplemental_report && files && files.length"
        >
          <h5 class="title">Attachment Files</h5>
          <div class="attachments-container">
            <div v-for="(fileData, index) in files" :key="index">
              <div class="each-attachment">
                <el-icon><Paperclip /></el-icon>
                <p class="file-name">{{ fileData.name }}</p>

                <el-button
                  type="text"
                  @click="remove"
                  class="btn-close"
                  size="sm"
                >
                  <img
                    class="hover"
                    src="@/assets/images/icons/attachments/attachment-success.svg"
                    alt=""
                  />
                  <img
                    src="@/assets/images/icons/attachments/remove-button.svg"
                    alt=""
                    class="without-hover"
                  />
                </el-button>
              </div>
            </div>
            <p
              class="err"
              v-if="
                getUploadTestReportValidationErrors &&
                getUploadTestReportValidationErrors.critical_error
              "
            >
              {{ getUploadTestReportValidationErrors.critical_error }}
            </p>
          </div>
        </div>
      </div>

      <div
        v-if="
          form.is_supplemental_report &&
          multiple_supplemental_report &&
          files &&
          files.length
        "
      >
        <div class="attach-upload-file">
          <h4>Attachment Files</h4>
        </div>
        <draggable
          v-if="multiple_supplemental_report"
          v-model="files"
          @start="drag = true"
          @end="drag = false"
          ghost-class="ghost"
          item-key="id"
          class="upload-file"
        >
          <template #item="{ element, index }">
            <div class="show-upload-file">
              <img src="@/assets/images/icons/view-attach-icon.svg" alt="" />
              <p class="upload-file-text">
                {{ index + 1 + "-" + element.name }}
              </p>
              <el-button
                @click="move(index, index - 1)"
                :disabled="index == 0"
                class="move-up-button"
              >
                <el-icon><top /></el-icon>
              </el-button>
              <el-button
                @click="move(index, index + 1)"
                :disabled="index == files.length - 1"
                class="move-button"
              >
                <el-icon><bottom /></el-icon>
              </el-button>
              <el-button @click="remove(index)" class="close-button">
                <el-icon><close /></el-icon>
              </el-button>
            </div>
          </template>
        </draggable>
      </div>
    </el-form>

    <el-tabs class="demo-tabs" v-if="progressBar" v-model="activeName">
      <el-tab-pane label="Uploaded Documents" name="uploadFiles">
        <div class="document-container">
          <div
            class="document-cell1"
            v-for="(file, index) in files"
            :key="index + '-' + file.percentage"
          >
            <img src="/img/pdf.03ed9640.svg" alt="" />
            <p class="file-name">
              {{ index + 1 + ") " + file.file.name }}
            </p>
            <el-progress :percentage="file.percentage"></el-progress>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
Array.prototype.move = function (from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
  return this;
};
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import draggable from "vuedraggable";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  components: {
    draggable,
  },
  data() {
    return {
      caseTypes: [],
      loading: false,
      activeName: "uploadFiles",
      multipleReports: [],

      progressBar: false,
      files: [],
      multiple_supplemental_report: false,
      form: {
        is_supplemental_report: false,
        case_type: "",
        title: "",
        mark_for_physician: false,
        reason: "",
        accession_id: "",
        test_report_source: "",
        covid_status: "",
        is_manual: true,
        is_covid: false,
        // supplemental_report_notes: "",
        supplemental_report_source: "",
        supplemental_reports: [],
        reference_by: "",
        result_status: "",
      },
      test_reports: [],
      covidStatuses: [
        {
          label: "POSITIVE",
          value: "POSITIVE",
        },
        {
          label: "NEGATIVE",
          value: "NEGATIVE",
        },
        {
          label: "INCONCLUSIVE",
          value: "INCONCLUSIVE",
        },
        {
          label: "RESULT AWAITED",
          value: "RESULT_AWAITED",
        },
      ],
      documentLoading: false,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      discreteFile: [],
      discreteFileList: [], // For UI clearing
      discreteResultsData: [],
    };
  },
  computed: {
    isPhysicianLogin() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type &&
        this.getAuthenticatedUser.user_type === "HOSPITAL_PHYSICIAN"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isLabAssistant() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type &&
        this.getAuthenticatedUser.user_type === "LAB_DATA_ASSISTANT"
      ) {
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters("cases", [
      "getCaseInformation",
      "getUploadTestReportData",
      "getAttachmentUploadStatus",
      "getUploadTestReportValidationErrors",
      "getMultipleReportsUploadData",
      "getMultipleUploadStatus",
      "getMergeCaseReportStatus",
      "getUploadMultipleTestReportStatus",
      "getGenerateDiscreteForSendoutStatus"
    ]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("resultFiles", ["getDiscreteResultSendStatus"]),
    checkReportTitle() {
      if (this.multiple_supplemental_report) {
        return false;
      } else if (this.form.is_supplemental_report) {
        return true;
      } else {
        return false;
      }
    },
    checkButtonDisabled() {
      if (!this.files || !this.files.length) {
        return true;
      }
      const isUTI = this.form.case_type === 'UTI';
      const requiresResultStatus = isUTI ? this.form.result_status : true; // only require for UTI

      // Condition 1: multiple supplemental report
      if (
        this.multiple_supplemental_report &&
        this.form.case_type &&
        this.form.reason &&
        this.form.title &&
        this.form.is_supplemental_report &&
        requiresResultStatus
      ) {
        return false;
      }

      // Condition 2: supplemental report case
      if (
        this.form.title &&
        this.form.is_supplemental_report &&
        this.form.case_type &&
        requiresResultStatus
      ) {
        if (isUTI) {
          const isMicrogen =
            this.getCaseInformation?.is_sendout &&
            this.getCaseInformation?.sendout?.received_lab?.name === 'Microgen Health';

          if (isMicrogen) {
            return this.discreteFileList.length === 0; // disable if no discrete files
          }
          return false; // unable for non-Microgen UTI
        }
        return false; // enable for non-UTI
      }

      // Condition 3: discrete file upload case - inhouse report
      if (
        this.form.case_type &&
        this.form.reason &&
        this.form.test_report_source &&
        requiresResultStatus
      ) {
        if (isUTI) {
          return this.discreteFileList.length === 0; // disable if no discrete files
        }
        return false;
      }

      return true;
    },
    checkSendout() {
      return this.getCaseInformation && this.getCaseInformation.is_sendout
        ? true
        : false;
    },
    resultTypeField() {
      const validCaseTypes = ['WOUND', 'NAIL', 'GASTRO','RESPIRATORY_PATHOGEN_PANEL', 'UTI'];
      return (this.form.is_supplemental_report && validCaseTypes.includes(this.form.case_type) || this.form.case_type === 'UTI');
    },
  },
  props: ["selectedCaseId"],
  async created() {
    await this.$store.commit("errors/clear", null, { root: true });
  },
  async mounted() {
    await this.$store.dispatch(
      "cases/fetchCaseInformation",
      this.$route.params.case_id || this.selectedCaseId
    );
    this.form.accession_id = this.getCaseInformation.accession_id;
    this.checkAllowCaseType();
    if (this.getCaseInformation && this.getCaseInformation.is_sendout) {
      this.form.is_supplemental_report = true;
      if (
        this.getCaseInformation &&
        this.getCaseInformation.sendout &&
        this.getCaseInformation.sendout.received_lab &&
        this.getCaseInformation.sendout.received_lab.name
      ) {
        this.form.reference_by =
          this.getCaseInformation.sendout.received_lab.name;
      }
    }
    if (
      this.getAuthenticatedUser &&
      this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
    ) {
      this.form.case_type = this.caseTypes[0];
    } else {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.case_types &&
        this.getCaseInformation.case_types.length
      ) {
        this.form.case_type = this.getCaseInformation.case_types[0];
      }
    }
    await this.$store.commit("errors/clear", null, { root: true });
    await this.$store.commit(
      "cases/setUploadTestReportValidationErrors",
      null,
      { root: true }
    );
    if (this.checkSendout && this.form.is_supplemental_report) {
      this.form.reason = "SENDOUT";
    }
  },
  methods: {
    async generateSendoutDiscreteResults(report) {
      try { 
        let labName = null
        if(
          this.getCaseInformation &&
          this.getCaseInformation.sendout &&
          this.getCaseInformation.sendout.received_lab &&
          this.getCaseInformation.sendout.received_lab.name
        ){
         labName =  this.getCaseInformation.sendout.received_lab.name
        }
        let params = {
          case_id:this.$route.params.case_id,
          report_id:report.test_report_id,
          sendout_lab:labName,
          case_types:this.getCaseInformation.case_types[0]
        }
        if (this.getCaseInformation?.case_types.includes("CLINICAL_CHEMISTRY")) {
          await this.$store.dispatch("cases/generateDiscreteSendoutReports", params)
          if (this.getGenerateDiscreteForSendoutStatus) {
            successNotification("Discrete results generated for the report")
          } else {
            errorNotification(this.getError || "Error while generating discrete results for the report")
          }
        }
        if (labName == "ADVANTA GENETICS") {
          await this.$store.dispatch("cases/generateDiscreteResultsAdvanta", params)
          if (this.getGenerateDiscreteForSendoutStatus) {
            successNotification("Discrete results generated for the report")
          } else {
            errorNotification(this.getError || "Error while generating discrete results for the report")
          }
        }
      } catch(err){
        console.log('err: ', err);
      }
    },
    async uploadDiscreteResultsFile(rowData) {
      const reader = new FileReader(this.discreteFile);

      // Define the keys you want to extract from the CSV
      const keysToExtract = [
        "display_name",
        "long_name",
        "ct_mean",
        "reference_range",
        "result",
        "antibiotic_resistance",
        "level",
      ];

      reader.onload = async (event) => {
        const csvData = event.target.result;
        const rows = csvData.split("\n");

        // Initialize an array to store objects containing extracted keys
        const extractedData = [];

        // Process each row of CSV data, starting from the second row (index 1)
        for (let i = 1; i < rows.length; i++) {
          const row = rows[i];
          const values = row.split(",");

          // Check if the row has enough values to match the keys to extract
          if (values.length >= keysToExtract.length) {
            // Create an object with the desired keys and corresponding values
            const dataObject = {};

            keysToExtract.forEach((key, index) => {
              // Trim each value to remove leading/trailing spaces
              const value = values[index] ? values[index].trim() : "";
              dataObject[key] = value;
            });

            // Check if the data object contains at least one non-empty value
            const hasValidData = Object.values(dataObject).some(
              (value) => value !== ""
            );

            if (hasValidData) {
              extractedData.push(dataObject); // Add the object to the extractedData array
            } else {
              console.warn(
                `Skipping row ${i + 1} with insufficient data: ${row}`
              );
            }
          } else {
            console.warn(
              `Skipping row ${i + 1} with insufficient data: ${row}`
            );
          }
        }

        // Check if extractedData array is empty after filtering
        if (extractedData.length === 0) {
          // Display an error notification if no valid rows were extracted
          errorNotification("Uploaded file does not contain any valid results");
          return; // Stop further processing
        }

        if (extractedData.length > 0) {
          extractedData.shift(); // Remove the first object
        }

        // Map extractedData to discreResults objects and push to discreteResultsData array
        const discreteResultsData = extractedData.map((results) => ({
          display_name: results.display_name
            ? results.display_name.replace(/"/g, "")
            : "",
          assay_id: results.long_name
            ? results.long_name.replace(/"/g, "")
            : "",
          ct_mean: parseFloat(results.ct_mean) || 0,
          result_nature: results.result ? results.result.replace(/"/g, "") : "",
          flags: results.level ? results.level.replace(/"/g, "") : "",
          reference_range: results.reference_range
            ? results.reference_range.replace(/"/g, "")
            : "",
          antibiotic_resistance: results.antibiotic_resistance
            ? results.antibiotic_resistance.replace(/"/g, "")
            : "",
          result_status: "F", // Set result_status to "F"
        }));

        this.discreteResultsData.push(...discreteResultsData);

        await this.sendDiscreteResults(rowData);
      };

      // Read the uploaded CSV file as text
      reader.readAsText(this.discreteFile.raw);
    },

    async sendDiscreteResults(report_id) {
      try {
        let params = {
          case_id: report_id.case_id,
          test_report_id: report_id.test_report_id,
          discrete_results: this.discreteResultsData,
        };
        await this.$store.dispatch("resultFiles/addDiscreteResults", params);
        if (this.getDiscreteResultSendStatus) {
          successNotification("Discrete results uploaded successfully");
          // Clear the discrete file and UI after successful upload
          this.discreteFile = [];
          this.discreteFileList = [];
          if (this.$refs.discreteUpload) {
            this.$refs.discreteUpload.clearFiles();
          }
        } else {
          errorNotification("Error while uploading discrete results");
        }
      } catch (error) {
        console.log(error);
      }
    },
    uploadDiscreteResults(file) {
      this.discreteFile = file;
      this.discreteFileList = [file];
    },
    checkAllowCaseType() {
      if (
        this.getAuthenticatedUser.allowed_case_types &&
        this.getAuthenticatedUser.allowed_case_types.length
      ) {
        if (
          this.getCaseInformation &&
          this.getCaseInformation.case_types &&
          this.getCaseInformation.case_types.length
        ) {
          this.caseTypes = this.getAuthenticatedUser.allowed_case_types.filter(
            (casetype) => this.getCaseInformation.case_types.includes(casetype)
          );
        }
      }
      return this.caseTypes;
    },
    async handleTypeChange() {
      this.multiple_supplemental_report = false;

      this.files = [];
      this.form.title = "";
      this.form.reason = "";
      // this.form.supplemental_report_notes = "";
      this.form.result_status = "";
      this.form.reference_by = "";
      this.discreteFile = [];
      this.discreteFileList = [];
      if (this.form.is_supplemental_report) {
        this.form.title = "";
      }
      await this.$store.commit("errors/clear", null, { root: true });
      await this.$store.commit(
        "cases/setUploadTestReportValidationErrors",
        null,
        { root: true }
      );
    },
    handleReportChange() {
      this.files = [];
      this.supplemental_reports = [];
      this.form.title = "";
      this.form.reason = "";
      // this.form.supplemental_report_notes = "";
      this.form.result_status = "", 
      this.form.reference_by = "";
    },
    // check file size
    beforeAvatarUpload(file) {
      // checking file size less than 100mb
      const checkSize = file.size / Math.pow(1024, 100) < 1;
      if (!checkSize) {
        this.$message.error("File size can not exceed 100MB!");
      }
      return checkSize;
    },
    // upload test results methods
    handleRemove() {
      this.files = [];
      this.form.test_report_source = "";
    },
    handleUpload(file) {
      this.files = [];
      if (this.beforeAvatarUpload(file)) {
        this.form.test_report_source = file.name;
        if (this.form.is_supplemental_report) {
          this.form.title = file.name;
        }
        const fileData = {
          file: file,
          name: file.name,
          error_message: null,
          percentage: 0,
        };
        this.files.push(fileData);
      }
    },
    beforeRemove(file) {
      return this.$confirm(`Cancel the transfert of ${file.name} ?`);
    },
    handleReportRemove(file) {
      this.files = [];
      this.form.test_report_source = "";
      return this.$confirm(`Cancel the transfert of ${file.name} ?`);
    },
    async handleMultipleFileUpload(file) {
      if (this.beforeAvatarUpload(file)) {
        const fileData = {
          file: file,
          name: file.name,
          error_message: null,
          percentage: 0,
          success: false,
          report_path: "",
        };

        this.files.push(fileData);
      }
      this.form.title = this.files[0].name;
    },

    remove(index) {
      this.$confirm("Are you sure want to DELETE File. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(async () => {
        await this.$store.commit("errors/clear", null, { root: true });
        await this.$store.commit(
          "cases/setUploadTestReportValidationErrors",
          null,
          { root: true }
        );
        (this.form.title = ""), await this.files.splice(index, 1);
      });
    },

    move(from, to) {
      this.files.move(from, to);
      this.form.title = this.files[0].name;
    },
    beforeReportRemove(file) {
      return this.$confirm(`Cancel the transfert of ${file.name} ?`);
    },
    prepareParamsForFileCreate(file) {
      return {
        file: file.raw.name,
        file_type: file.raw.type,
        file_size: file.raw.size / 1000,
        case_id: this.$route.params.case_id || this.selectedCaseId,
        type: this.form.case_type,
      };
    },
    async prepareMultipleReportsData() {
      for (let fileIndex = 0; fileIndex < this.files.length; fileIndex++) {
        this.files[fileIndex].percentage = 0;
        let data = this.prepareParamsForFileCreate(this.files[fileIndex].file);
        await this.$store.dispatch("cases/fetchFileUploadUrl", data);
        if (
          this.getMultipleReportsUploadData &&
          this.getMultipleReportsUploadData.target_url
        ) {
          this.files[fileIndex].percentage = 30;
          this.files[fileIndex].report_path =
            this.getMultipleReportsUploadData.path || "";

          let params = {
            file: this.files[fileIndex].file.raw,
            upload_url: this.getMultipleReportsUploadData.target_url,
          };
          await this.$store.dispatch(
            "cases/uploadDocumentToGeneratedUrlForAttachments",
            params
          );
          if (this.getAttachmentUploadStatus) {
            this.files[fileIndex].percentage = 70;

            let params = {
              case_id: this.$route.params.case_id || this.selectedCaseId,
              ref_id: this.getMultipleReportsUploadData.hash,
            };
            await this.$store.dispatch("cases/updateTestReportStatus", params);
            this.files[fileIndex].percentage = 100;
            this.files[fileIndex].status = true;
          }
        }
      }
    },
    async onSubmitMultipleTestReports() {
      this.files.percentage = 0;
      this.progressBar = true;
      await this.prepareMultipleReportsData();
      this.loading = true;

      let params = this.prepareMultipleReportsFormData();
      await this.$store.dispatch("cases/uploadMultipleTestReports", params);
      if (this.getUploadMultipleTestReportStatus) {
        await this.onGenerate(this.getUploadMultipleTestReportStatus);
      }
      this.loading = false;
      this.progressBar = false;
      if (this.getMultipleUploadStatus) {
        let query = {
          selected_panel: this.form.case_type,
        };
        this.$emit("uploadedTestReports");
        this.resetFormData();

        this.$router.push({
          query: { ...this.$route.query, selected_panel: query.selected_panel },
        });

        this.$notify({
          title: "Success",
          message: "Test Report Uploaded Successfully",
          type: "success",
        });
      } else {
        this.form.supplemental_reports = [];
        for (let i = 0; i < this.files.length; i++) {
          this.files[i].percentage = 0;
        }
        if (!this.getUploadTestReportValidationErrors) {
          this.$notify.error({
            title: "Error",
            message: "Error in Uploading Test Report Files",
          });
        }
      }
    },
    prepareMultipleReportsFormData() {
      let formData = { ...this.form };
      let reportsData = [];
      for (let i = 0; i < this.files.length; i++) {
        formData.test_report_source = this.files[i].name;
        reportsData.push({
          report_source: this.files[i].report_path,
          report_title: this.files[i].name,
          order: i + 1,
        });
      }
      formData.supplemental_reports = reportsData;
      let params = {
        case_id: this.$route.params.case_id || this.selectedCaseId,
        form_data: formData,
      };
      params.form_data.is_multiple = true;
      if (this.form.case_type != "COVID") {
        delete params.form_data.covid_status;
      }
      return params;
    },
    async onSubmitTestReports(fileIndex = 0, redirectToCaseFiles = true) {
      this.documentLoading = true;

      try {
        this.form.is_covid = this.form.case_type == "COVID" ? true : false;

        if (this.form.is_supplemental_report) {
          this.form.title = this.form.test_report_source;
        }

        let params = {
          case_id: this.$route.params.case_id || this.selectedCaseId,
          form_data: this.form,
        };
        delete params.form_data.supplemental_reports;
        if (this.form.case_type != "COVID") {
          delete params.form_data.covid_status;
        }

        // store test reports data and get pre signed url
        await this.$store.dispatch("cases/uploadTestReports", params);
        if (
          this.getUploadTestReportData &&
          this.getUploadTestReportData.target_url
        ) {
          let data = this.getUploadTestReportData;

          let uploadParams = {
            upload_url: data.target_url,
            file: this.files[fileIndex].file.raw,
          };
          // store the file on s3 bucket using presigned url
          await this.$store.dispatch(
            "cases/uploadDocumentToGeneratedUrl",
            uploadParams
          );

          // update the uploaded file status
          if (this.getAttachmentUploadStatus) {
            await this.$store.dispatch("cases/updateTestReportStatus", data);
            if (this.discreteFile) {
              this.uploadDiscreteResultsFile(this.getUploadTestReportData);
            }
            const parallelTasks = [];
            if (this.form.is_supplemental_report) {
              parallelTasks.push(this.onGenerate(this.getUploadTestReportData));
            }
            if (
              this.getCaseInformation &&
              this.getCaseInformation.is_sendout &&
              this.getCaseInformation.sendout?.received_lab?.name !== "Microgen Health"
            ) {
              parallelTasks.push(this.generateSendoutDiscreteResults(this.getUploadTestReportData));
            }
            if (parallelTasks.length) {
              await Promise.all(parallelTasks);
            }
            // showing uploaded case type tab
            if (redirectToCaseFiles) {
              let query = {
                selected_panel: this.form.case_type,
              };
              this.$emit("uploadedTestReports");
              this.resetFormData();

              this.$router.push({
                query: {
                  ...this.$route.query,
                  selected_panel: query.selected_panel,
                },
              });
            }
            this.$notify({
              title: "Success",
              message: "Test Report Uploaded Successfully",
              type: "success",
            });
          } else {
            this.files[fileIndex].error_message =
              "Error in Uploading Test Report Files";
            this.$notify.error({
              title: "Error",
              message: "Error in Uploading Test Report Files",
            });
          }
        }
        this.documentLoading = false;
      } catch (err) {
        console.log(err);
        this.$notify.error({
          title: "Error",
          message: "Error in Uploading Test Report Files",
        });
      }
    },
    async onGenerate(report) {
      try {
        this.loading = true;
        this.loadingText = "Merging report...";
        let params = {
          case_id: report.case_id,
          report_id: report.test_report_id,
        };
        await this.$store.dispatch("cases/mergeCaseReport", params);
        if (this.getMergeCaseReportStatus) {
          this.$notify({
            title: "Success",
            message: "Report Merged Successfully",
            type: "success",
          });
        } else {
          this.$notify.error({
            title: "Error",
            message: "Error in Merging Report",
          });
        }
        this.loading = false;
        this.loadingText = "";
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    resetFormData() {
      this.file = "";
      this.form.is_supplemental_report = false;
      this.form.case_type = "";
      this.form.title = "";
      this.form.mark_for_physician = false;
      this.form.reason = "";
      this.form.test_report_source = "";
      this.form.covid_status = "";
      this.form.is_manual = true;
      this.form.is_covid = false;
      // this.form.supplemental_report_notes = "";
      this.form.result_status = "",
      this.form.supplemental_report_source = "";
      this.multiple_supplemental_report = false;
      this.files = [];
      this.progressBar = false;
      this.form.supplemental_reports = [];
      this.test_reports = [];
      this.form.reference_by = "";
    },
  },
};
</script>
<style lang="scss">
@import "/src/assets/scss/mixins/app.scss";

.upload-btn {
  padding-left: 25em;
}
#uploadTestReports {
  max-width: 600px;
  margin: 1em auto 0;
  .el-form {
    .el-form-item__label {
      line-height: 30px !important;
    }
    .inline-switch {
      .el-form-item__content {
        line-height: 30px;
      }
    }
  }
}
.test-reports-input-container {
  display: grid;
  grid-template-columns: auto 30%;
  .test-tabs {
    padding: 15px;
  }
}

.test-tabs {
  .el-tabs__header {
    margin-bottom: 0 !important;
  }
  .test-reports {
    // margin-top: 15px;
    .case-type-left {
      width: 15.6666666667%;
    }
    .document-reports {
      display: flex;
      @include checkbox-styles;
    }
  }
  .case-type-left {
    // margin-top: 4rem;
    display: inline;
    .error {
      color: red;
    }
    .el-select {
      .el-input__inner {
        border: 1px solid #56ccf2cc;
        height: 30px;
        box-shadow: none;
      }
    }
    .el-form-item__label {
      font-weight: 500;
      color: #000000;
      line-height: 15px;
    }
  }
}

.types {
  // padding-top: 3.4rem !important;
  .input-value {
    .name-report {
      flex: 0 0 auto;
      text-align: right;
      font-size: var(--el-form-label-font-size);
      font-weight: 500;
      color: #000000;
      line-height: 15px;
      box-sizing: border-box;
    }
    .el-form-item__label {
      line-height: 15px;
      font-weight: 500;
      color: #000000;
    }
    .el-upload {
      width: 100%;
    }
    .upload-demo {
      margin-top: 4.5px;
    }
    .star {
      color: #f24a55;
    }
  }
  .view-report {
    margin-top: 27px !important;
    .btn {
      border: none !important;
    }
  }
}
.attach-upload-file {
  border-bottom: 1.5px solid #e7e7f7;
  h4 {
    font-size: 14px;
    color: #828282;
    font-weight: 400;
    padding: 0 15px;
  }
}
.upload-file {
  display: grid;
  grid-template-columns: 33.3% 33.3% 33.3%;
  align-items: center;
  padding: 1rem 0.5rem;

  .show-upload-file {
    border: 1px solid #e0e0e0;
    padding: 4px;
    display: flex;
    align-items: center;
    border-radius: 5px;
    margin: 10px;

    .upload-file-text {
      width: 80%;
      color: #828282;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    img {
      width: 16px;
      position: relative;
      height: 16px;
      padding: 0 5px;
      bottom: 1px;
    }
  }
}
.el-button {
  &:hover {
    background: none;
    // border: 1px solid #f0f2f5;
  }
}
.move-up-button {
  min-height: 25px;
  padding: 0px;
  margin: 0 0 0 10px;
  height: 22px;
  width: 23px;
  color: #f28b0c;
  &:hover {
    color: #f28b0c;
    border: 0.4px solid #bdbdbd;
  }
}

.move-button {
  min-height: 25px;
  padding: 0px;
  margin: 0 0 0 10px;
  height: 22px;
  width: 23px;
  color: green;
  &:hover {
    color: green;
    border: 0.4px solid #bdbdbd;
  }
}

.close-button {
  min-height: 25px;
  padding: 0px;
  margin: 0 0 0 10px;
  height: 22px;
  width: 23px;
  color: #eb5757;

  &:hover {
    border: 0.4px solid #bdbdbd;
    color: #eb5757;
  }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.btn-tag {
  text-align: center;
  height: 3px;

  font-size: 0.7rem;
}

.list-group-item {
  cursor: move;
  cursor: pointer;
  min-height: 20px;
}
.document-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 10px;
  padding-bottom: 10px;

  .document-cell1 {
    display: grid;
    grid-template-columns: 30px 50% auto;
    width: 90%;
    margin: 15px auto 0;
    align-items: center;
    border: 1px solid #56ccf2;
    padding: 0 0.3rem;
    border-radius: 7px;
    background-color: #fff;
    img {
      width: 20px;
      height: 20px;
    }
    .cancel {
      width: 15px;
      height: 15px;
    }
    .file-name {
      margin-bottom: 0;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 14px;
      font-weight: 500;
    }
    .el-progress {
      .el-progress__text {
        margin-left: 10px;
      }
      .el-progress-bar {
        .el-progress-bar__outer {
          height: 4px !important;
          background-color: #56ccf2;
        }
        .el-progress-bar__inner {
          height: 4px !important;
          background-color: #2d9cdb;
        }
      }
    }
    .demo-progress {
      .el-progress--line {
        width: 230px;
        .el-progress-bar__outer {
          background-color: #9ae0f7;
          height: 5px !important;
        }
        .el-progress-bar__inner {
          background-color: #2d9cdb;
          height: 5px;
        }
      }
      .el-progress__text {
        color: #828282;
      }
    }
  }
}

.attached-files {
  height: 100%;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 1px;
    height: 100%;
    background: #dbdbdb;
  }
  .title {
    border-bottom: 1px solid #dbdbdb;
    margin-bottom: 0.5rem;
    font-size: 14px;
    font-weight: 500;
    padding: 5px 10px;
    color: #eb5757;
  }
  .attachments-container {
    padding-bottom: 10px;
    padding: 5px 15px 10px;

    .each-attachment {
      padding: 0 0 0 10px;
      display: grid;
      border-radius: 5px;
      border: 1px solid #e0e0e0;
      align-items: center;
      grid-template-columns: 25px 1fr 30px;
      .file-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .el-button {
        .without-hover {
          display: none;
          transition: all 0.2s ease-in-out;
        }
        .hover {
          display: block;
          transition: all 0.2s ease-in-out;
        }
        &:hover {
          .without-hover {
            display: block;
            transition: all 0.2s ease-in-out;
          }
          .hover {
            display: none;
            transition: all 0.2s ease-in-out;
          }
        }
      }
    }
  }
}
.mandatory-field {
  .el-form-item__label::after {
    content: "*";
    color: red;
    position: relative;
    left: 3px;
  }
}
.auto-upload {
  .el-upload-list__item {
    padding: 3px 0 0 0;
    border-radius: 5px;
    border: 1px solid #e0e0e0;
    height: 30px;
    margin-top: 5px;
    display: flex;

    .el-icon {
      bottom: 3px;
      position: relative;
      margin-right: 3px;
      color: #273480;
    }
  }
  .el-upload-list__item-name {
    color: #273480;
    font-weight: 500;
    margin-right: 15px;
  }
}
</style>
